import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { IconDown } from 'blocket-ui'
import { ie11media, mediaQueries } from '@blazar-plugins/device'

const StyledLabel = styled.label`
  display: block;
  background-color: white;
  position: relative;
  border: 1px solid #9a9999;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  ${({ disabled }) => disabled && `opacity: 0.5`}
`

const StyledSelect = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding: 8px 48px 8px 40px;
  appearance: none;
  border: none;
  background-color: transparent;
  font-family: 'BlocketSans-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #707274;
  line-height: 26px;

  font-size: 15px;
  @media ${mediaQueries.large} {
    font-size: 17px;
  }

  ${ie11media} {
    &::-ms-expand {
      display: none;
    }
    padding-top: 12px;
  }
`

const StyledIconDown = styled(IconDown)`
  position: absolute;
  pointer-events: none;
  right: 17px;
  top: 14px;
`

const GeoDropdown = ({
  id,
  className,
  options,
  children,
  value,
  onChange,
  disabled,
  selectClassName = '',
  ...props
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value || undefined
    onChange(e, newValue)
  }

  return (
    <StyledLabel htmlFor={id} disabled={disabled} className={className}>
      {children}
      <StyledSelect
        onChange={handleChange}
        value={value}
        disabled={disabled}
        className={selectClassName}
        {...props}
      >
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          )
        })}
      </StyledSelect>
      <StyledIconDown width="20px" height="20px" color="#696766" />
    </StyledLabel>
  )
}

export default GeoDropdown

GeoDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, label: PropTypes.string })),
  value: PropTypes.array,
  children: PropTypes.node,
  className: PropTypes.string,
  selectClassName: PropTypes.string,
  disabled: PropTypes.bool,
}
